<template>
  <div
    class="checkbox"
    :data-cy="slug"
  >
    <div class="m-form-wrap-elements m-form-wrap-elements--no-padding">
      <div class="m-form-wrap-elements__flex">
        <div
          class="m-form-element m-form-element--no-padding js-m-form-element"
          :class="{'state-m-form-element--input-error': v$[slug] && v$[slug].$error}"
        >
          <fieldset class="m-checkbox-group m-checkbox-group--vertical-group ">
            <ul class="m-checkbox-group__list">
              <li class="m-checkbox-group__item">
                <div
                  data-g-name="Checkbox"
                  class="a-checkbox"
                >
                  <!-- Checkbox -->
                  <input
                    :id="slug"
                    type="checkbox"
                    class="a-checkbox__input js-a-checkbox__input"
                    :name="slug"
                    :checked="isChecked"
                    @change="updateInput"
                  >

                  <!-- Label -->
                  <label
                    class="a-checkbox__label"
                    :for="slug"
                  >
                    <span class="a-checkbox__label-text">{{ label }}</span>
                  </label>
                </div>
              </li>
            </ul>
          </fieldset>

          <!-- Message d'erreur -->
          <ErrorMessage :validation-status="v$[slug]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ErrorMessage from "./ErrorMessage";

/**
 * Simple checkbox qui ne permets que de faire un choix binaire (coché ou non coché)
 */
export default {
  name: "SimpleInputCheckbox",
  components: {
    ErrorMessage
  },
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    trueValue: {
      type: String,
      required: true
    },
    falseValue: {
      type:String,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  emits: [
      'changeValue'
  ],
  computed: {
    isChecked() {
      return this.model === this.trueValue
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      this.$emit('changeValue', isChecked ? this.trueValue : this.falseValue)
    }
  }
}
</script>

<style scoped>

</style>
